<div class="user-icon-circle-container">
  <span class="icon icon-user-profile h3" *ngIf="!userImage"></span>
  <img [src]="userImage" *ngIf="userImage" class="user-profile-picture" alt="Profile Picture" />
</div>
